<template>
    <div class="block-editor tavily-web-search">
        <div class="editor-row">
            <div class="editor-row-title">Arama Sorgusu</div>
            <TiptapEditor placeholder="Arama sorgusu girin" :show-attributes="true" :show-emoji="false" v-model="clone.query" />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Arama Derinliği</div>
            <a-select v-model="clone.search_depth">
                <a-select-option value="basic">Temel</a-select-option>
                <a-select-option value="advanced">Gelişmiş</a-select-option>
            </a-select>
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Ham İçeriği Dahil Et</div>
            <a-switch v-model="clone.include_raw_content" />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Görselleri Dahil Et</div>
            <a-switch v-model="clone.include_images" />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Görsel Açıklamalarını Dahil Et</div>
            <a-switch v-model="clone.include_image_descriptions" />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Cevabı Dahil Et</div>
            <a-switch v-model="clone.include_answer" />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Dahil Edilecek Alan Adları</div>
            <div v-for="(domain, index) in clone.include_domains" :key="'domain-' + index" class="key-value-pair">
                <a-input v-model="clone.include_domains[index]" placeholder="Alan adı (örn: example.com)" class="domain-input" />
                <a-button type="link" danger @click="removeDomain(index)">
                    <span class="material-icons">delete</span>
                </a-button>
            </div>
            <a-button type="dashed" block @click="addDomain" class="add-btn">
                <span class="material-icons">add</span> Alan Adı Ekle
            </a-button>
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Maksimum Sonuç Sayısı</div>
            <a-input-number v-model="clone.max_results" :min="1" :max="10" />
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";

export default {
    name: "TavilyWebSearch",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            query: "",
            search_depth: "basic", // basic, advanced
            include_raw_content: true,
            include_images: false,
            include_image_descriptions: false,
            include_answer: true,
            include_domains: ["example.com"],
            max_results: 5
        };
        
        // Eğer include_domains bir dizi değilse, dizi olarak ayarla
        if (!Array.isArray(clone.include_domains)) {
            clone.include_domains = ["example.com"];
        }
        
        return {
            clone
        };
    },
    methods: {
        addDomain() {
            this.clone.include_domains.push("");
        },
        removeDomain(index) {
            this.clone.include_domains.splice(index, 1);
        }
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            }
        }
    }
};
</script>

<style lang="scss">
.block-editor.tavily-web-search {
    padding: 20px;

    .editor-row {
        margin-bottom: 20px;

        .editor-row-title {
            font-weight: bold;
            margin-bottom: 10px;
            font-size: 16px;
        }
    }

    .key-value-pair {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;

        .domain-input {
            flex: 1;
        }

        .material-icons {
            font-size: 20px;
        }
    }

    .add-btn {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;

        .material-icons {
            font-size: 18px;
        }
    }
}
</style> 